<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <h2 class="text-xs-center mb-3">Community Space</h2>
      <v-layout row wrap>
        <template v-for="(community, index) in communities">
          <v-flex xs12 sm3 :key="index">
            <v-card color="white" class="black--text">
              <v-layout>
                <v-flex xs5>
                  <v-img :src="require('@/assets/thumbnail-' + community.id + '.png')"
                         height="125px" class="ml-3" contain></v-img>
                </v-flex>
                <v-flex xs7>
                  <v-card-title primary-title>
                    <div class="title" v-html="community.name"></div>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <v-rating v-model="community.rating" background-color="white" color="yellow accent-4"
                          dense half-increments hover size="18"></v-rating>
                <span class="grey--text caption mr-2">
                  ({{ community.rating }})
                </span>
                <v-spacer></v-spacer>
                <v-btn :color="community.btnColor" class="white--text"
                       @click="goToCommunity(community.id)">join us</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </template>

        <v-flex xs12 sm3>
          <v-card color="grey" class="black--text" height="210px">
            <v-layout align-center justify-center row fill-height>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn round color="teal" dark>Add Community Space</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'CommunitySpace',
  data: () => ({
    communities: [
      { id: 'lollspace-alpha', name: 'LollSpace Community(&alpha;)', btnColor: 'teal', rating: 5 },
      { id: 'niishi.kubo', name: 'Hello, My Space!', btnColor: '#e73291', rating: 5 },
      // { id: 'firebase', name: 'Firebase User Group', btnColor: '#F57C00', rating: 5 },
      { id: 'spotify', name: 'Spotify User Community JP', btnColor: '#1DB954', rating: 5 },
      { id: 'kojin-dev', name: 'kojin-dev [個人開発者同士のコミュニティ]', btnColor: '#424242', rating: 5 },
    ],
  }),
  methods: {
    goToCommunity(communityId) {
      this.$router.push(`/c/${communityId}`);
    },
  },
};
</script>
